import { disputeManagementConstants } from "../_constants";
import { alertActions } from "./alert.actions";
import {
    APIcallFunction,
    headerForPrivateAPI,
} from "../_helpers";

export const disputeManagementAction = {
    getDisputeMessageList,
    createDisputeMessage,
    updateDisputeMessage,
    deleteDisputeMessage,
    UpdateDisputeMessageStatus,

    getDisputeCategoryList,
    createDisputeCategory,
    updateDisputeCategory,
    deleteDisputeCategory,
    UpdateDisputeCategoryStatus,

    getAdvertisementList,

    getTermsTagList,
    createTermsTags,
    updateTermsTags,
    deleteTermsTags,
    UpdateTermsTagsStatus,

    updateDisputeRaised,
    getDisputeRaisedList,


    getCoinTrade,
    createCoinTrade,
    updateCoinTrade,
    deleteCoinTrade,
    UpdateCoinTradeStatus,
    getAllCoinList,

    getChatDetailOnBehalfOrderIdForAdmin,
    getChatMessageListByChatId,
    getChatDetailsById,
    userBankDetailsList,
    updateUserBankDetailsStatus,
    getChatMessageListByChatIdForAdmin,
    replyMessageOnChat,

    // transaction dispute
    getTransactionDisputeList,
    updateTransactionDisputeRaised,
    getMerchantDisputeStats
};

//dispute management messages

//get
function getDisputeMessageList(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/dispute/getDisputeMessageList",
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
                //dispatch(alertActions.success("Data Found"));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) {
        return {
            type: disputeManagementConstants.GET_DISPUTEMESSAGE_LIST_REQUEST,
            user,
        };
    }
    function success(user) {
        return {
            type: disputeManagementConstants.GET_DISPUTEMESSAGE_LIST_SUCCESS,
            user,
        };
    }
    function failure(error) {
        return {
            type: disputeManagementConstants.GET_DISPUTEMESSAGE_LIST_FAILURE,
            error,
        };
    }
}

//create
function createDisputeMessage(data, ref) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/dispute/createDisputeMessage",
    };
    return APIcallFunction(credentials)
}

//update
function updateDisputeMessage(data, rest) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/dispute/updateDisputeMessage",
    };
    return APIcallFunction(credentials)
}

//delete
function deleteDisputeMessage(data, rest) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/dispute/deleteDisputeMessage",
    };
    return APIcallFunction(credentials)
}

function UpdateDisputeMessageStatus(data, details) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/dispute/updateDisputeMessageStatus",
    };
    return APIcallFunction(credentials)
}

//dispute management category

//get
function getDisputeCategoryList(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/dispute/getDisputeCategoryList",
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
                //dispatch(alertActions.success("Data Found"));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) {
        return {
            type: disputeManagementConstants.GET_DISPUTECATEGORY_LIST_REQUEST,
            user,
        };
    }
    function success(user) {
        return {
            type: disputeManagementConstants.GET_DISPUTECATEGORY_LIST_SUCCESS,
            user,
        };
    }
    function failure(error) {
        return {
            type: disputeManagementConstants.GET_DISPUTECATEGORY_LIST_FAILURE,
            error,
        };
    }
}

//create
function createDisputeCategory(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/dispute/createDisputeCategory",
    };
    return APIcallFunction(credentials)
}

//update
function updateDisputeCategory(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/dispute/updateDisputeCategory",
    };
    return APIcallFunction(credentials)
}

//delete
function deleteDisputeCategory(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/dispute/deleteDisputeCategory",
    };
    return APIcallFunction(credentials)
}

function UpdateDisputeCategoryStatus(data, details) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/dispute/updateDisputeCategoryStatus",
    };
    return APIcallFunction(credentials)
}

function getAdvertisementList(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/advertisement/getAdvertisementListAdmin",
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
                //dispatch(alertActions.success("Data Found"));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) {
        return { type: disputeManagementConstants.GET_ADVERTISEMENT_LIST_REQUEST, user };
    }
    function success(user) {
        return { type: disputeManagementConstants.GET_ADVERTISEMENT_LIST_SUCCESS, user };
    }
    function failure(error) {
        return {
            type: disputeManagementConstants.GET_ADVERTISEMENT_LIST_FAILURE,
            error,
        };
    }
}


//Terms and tags
function getTermsTagList(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/termTag/getTermTagList",
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
                //dispatch(alertActions.success("Data Found"));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) {
        return {
            type: disputeManagementConstants.GET_TERMS_LIST_REQUEST,
            user,
        };
    }
    function success(user) {
        return {
            type: disputeManagementConstants.GET_TERMS_LIST_SUCCESS,
            user,
        };
    }
    function failure(error) {
        return {
            type: disputeManagementConstants.GET_TERMS_LIST_FAILURE,
            error,
        };
    }
}

//create
function createTermsTags(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/termTag/createTermTag",
    };
    return APIcallFunction(credentials)
}

//update
function updateTermsTags(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/termTag/updateTermTag",
    };
    return APIcallFunction(credentials)
}

//delete
function deleteTermsTags(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/termTag/deleteTermTag",
    };
    return APIcallFunction(credentials)
}

function UpdateTermsTagsStatus(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/termTag/updateTermTagStatus",
    };
    return APIcallFunction(credentials)
}


function getDisputeRaisedList(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/order/disputeRaisedList",
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (disputeRaised) => {
                dispatch(success(disputeRaised));
                //dispatch(alertActions.success("Data Found"));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(disputeRaised) {
        return {
            type: disputeManagementConstants.GET_DISPUTERAISEDLIST_REQUEST,
            disputeRaised,
        };
    }
    function success(disputeRaised) {
        return {
            type: disputeManagementConstants.GET_DISPUTERAISEDLIST_SUCCESS,
            disputeRaised,
        };
    }
    function failure(error) {
        return {
            type: disputeManagementConstants.GET_DISPUTERAISEDLIST_FAILURE,
            error,
        };
    }
}


function updateDisputeRaised(data, rest) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/order/resolveDeclineDisputeAppeal",
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
                dispatch(alertActions.success(user?.message || "Dispute status updated successfully."));
                dispatch(disputeManagementAction.getDisputeRaisedList(rest));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) {
        return {
            type: disputeManagementConstants.UPDATE_DISPUTEAPPEAL_REQUEST,
            user,
        };
    }
    function success(user) {
        return {
            type: disputeManagementConstants.UPDATE_DISPUTEAPPEAL_SUCCESS,
            user,
        };
    }
    function failure(error) {
        return {
            type: disputeManagementConstants.UPDATE_DISPUTEAPPEAL_FAILURE,
            error,
        };
    }
}


function getCoinTrade(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: '/coinTradeLimit/getCoinTradeLimitList'
    }
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (coin) => {
                dispatch(success(coin));
                //dispatch(alertActions.success("Data Found"));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(coin) { return { type: disputeManagementConstants.GET_COINTRADE_DETAILS_REQUEST, coin } }
    function success(coin) { return { type: disputeManagementConstants.GET_COINTRADE_DETAILS_SUCCESS, coin } }
    function failure(error) { return { type: disputeManagementConstants.GET_COINTRADE_DETAILS_FAILURE, error } }
}

//create
function createCoinTrade(data, ref) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/coinTradeLimit/createCoinTradeLimit",
    };
    return APIcallFunction(credentials)
}

//update
function updateCoinTrade(data, rest) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/coinTradeLimit/updateCoinTradeLimit",
    };
    return APIcallFunction(credentials)
}

//delete
function deleteCoinTrade(data, rest) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/coinTradeLimit/deleteCoinTradeLimit",
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
                dispatch(disputeManagementAction.getCoinTrade(rest));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) {
        return {
            type: disputeManagementConstants.DELETE_COINTRADE_REQUEST,
            user,
        };
    }
    function success(user) {
        return {
            type: disputeManagementConstants.DELETE_COINTRADE_SUCCESS,
            user,
        };
    }
    function failure(error) {
        return {
            type: disputeManagementConstants.DELETE_COINTRADE_FAILURE,
            error,
        };
    }
}

function UpdateCoinTradeStatus(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/coinTradeLimit/updateCoinTradeLimitStatus",
    };

    return APIcallFunction(credentials)

}


function getAllCoinList(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: '/coin/getAllCoin',
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
                //dispatch(alertActions.success("Data Found"));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) {
        return {
            type: disputeManagementConstants.GET_COINLIST_DETAILS_REQUEST,
            user,
        };
    }
    function success(user) {
        return {
            type: disputeManagementConstants.GET_COINLIST_DETAILS_SUCCESS,
            user,
        };
    }
    function failure(error) {
        return {
            type: disputeManagementConstants.GET_COINLIST_DETAILS_FAILURE,
            error,
        };
    }
}

function getChatDetailOnBehalfOrderIdForAdmin(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/order/getChatDetailOnBehalfOrderIdForAdmin",
    };
    return APIcallFunction(credentials)
}

function getChatMessageListByChatId(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/order/getChatMessageListByChatId",
    };
    return APIcallFunction(credentials)
}

function getChatDetailsById(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/order/getChatDetailsById"
    }
    return APIcallFunction(credentials)
}


function userBankDetailsList(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: '/userBankDetails/userBankDetailsList '
    }
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) { return { type: disputeManagementConstants.GET_BANK_DETAILS_REQUEST, user } }
    function success(user) { return { type: disputeManagementConstants.GET_BANK_DETAILS_SUCCESS, user } }
    function failure(error) { return { type: disputeManagementConstants.GET_BANK_DETAILS_FAILURE, error } }
}


function updateUserBankDetailsStatus(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/userBankDetails/updateUserBankDetailsStatus"
    }
    return APIcallFunction(credentials)
}

function getChatMessageListByChatIdForAdmin(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/order/getChatMessageListByChatIdForAdmin",
    };
    return APIcallFunction(credentials)
}

function replyMessageOnChat(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/order/replyMessageOnChat",
    };
    return APIcallFunction(credentials)
}


// transaction dispute


function getTransactionDisputeList(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/merchantDispute/getAdminDisputeList",
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
                //dispatch(alertActions.success("Data Found"));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) {
        return {
            type: disputeManagementConstants.GET_TRANSACTIONDISPUTE_LIST_REQUEST,
            user,
        };
    }
    function success(user) {
        return {
            type: disputeManagementConstants.GET_TRANSACTIONDISPUTE_LIST_SUCCESS,
            user,
        };
    }
    function failure(error) {
        return {
            type: disputeManagementConstants.GET_TRANSACTIONDISPUTE_LIST_FAILURE,
            error,
        };
    }
}


function updateTransactionDisputeRaised(data, rest) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/merchantDispute/resolveDispute",
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
                dispatch(alertActions.success("Dispute status updated successfully."));
                dispatch(disputeManagementAction.getTransactionDisputeList(rest));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) {
        return {
            type: disputeManagementConstants.UPDATE_TRANSACTIONDISPUTE_REQUEST,
            user,
        };
    }
    function success(user) {
        return {
            type: disputeManagementConstants.UPDATE_TRANSACTIONDISPUTE_SUCCESS,
            user,
        };
    }
    function failure(error) {
        return {
            type: disputeManagementConstants.UPDATE_TRANSACTIONDISPUTE_FAILURE,
            error,
        };
    }
}


function getMerchantDisputeStats(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/merchantDispute/getDisputeStats",
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
                //dispatch(alertActions.success("Data Found"));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) {
        return { type: disputeManagementConstants.GET_DISPUTESTATS_REQUEST, user };
    }
    function success(user) {
        return { type: disputeManagementConstants.GET_DISPUTESTATS_SUCCESS, user };
    }
    function failure(error) {
        return {
            type: disputeManagementConstants.GET_DISPUTESTATS_FAILURE,
            error,
        };
    }
}


